"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpanThumb = exports.StyledSpanInfo = exports.StyledSpanFileSize = exports.StyledSpanFileNameLink = exports.StyledSpanFileName = exports.StyledSpanFile = exports.StyledSpanActions = exports.StyledProgress = exports.StyledListItem = exports.StyledErrorIcon = exports.StyledDivContent = exports.StyledDeleteIcon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const flexCenter = {
  display: 'flex',
  alignItems: 'center'
};
const StyledListItem = exports.StyledListItem = (0, _mui.styled)('li')(({
  theme
}) => ({
  position: 'relative',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:last-child': {
    borderBottom: 'none'
  }
}));
const StyledDivContent = exports.StyledDivContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  ...flexCenter,
  justifyContent: 'space-between'
}));
const StyledSpanInfo = exports.StyledSpanInfo = (0, _mui.styled)('span')(({
  theme
}) => ({
  ...flexCenter,
  maxWidth: 'calc(100% - 50px)',
  width: '100%'
}));
const StyledSpanThumb = exports.StyledSpanThumb = (0, _mui.styled)('span')(({
  theme
}) => ({
  ...flexCenter,
  justifyContent: 'center',
  minWidth: '80px',
  minHeight: '80px',
  marginRight: theme.spacing(3)
}));
const StyledSpanActions = exports.StyledSpanActions = (0, _mui.styled)('span')(({
  theme
}) => ({
  ...flexCenter,
  justifyContent: 'flex-end'
}));
const StyledSpanFile = exports.StyledSpanFile = (0, _mui.styled)('span')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%'
}));
const StyledSpanFileName = exports.StyledSpanFileName = (0, _mui.styled)('span')(({
  theme
}) => ({
  display: 'block',
  overflow: 'hidden',
  color: theme.palette.text.primary,
  fontSize: '14px',
  lineHeight: '19px',
  textOverflow: 'ellipsis',
  whitespace: 'nowrap'
}));
const StyledSpanFileNameLink = exports.StyledSpanFileNameLink = (0, _mui.styled)('a')(({
  theme
}) => ({
  display: 'block',
  overflow: 'hidden',
  color: theme.palette.text.primary,
  fontSize: '14px',
  lineHeight: '19px',
  textOverflow: 'ellipsis',
  whitespace: 'nowrap',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline'
  }
}));
const StyledSpanFileSize = exports.StyledSpanFileSize = (0, _mui.styled)('span')(({
  theme
}) => ({
  color: theme.palette.grey.A700,
  fontSize: '11px',
  lineHeight: '18px'
}));
const StyledErrorIcon = exports.StyledErrorIcon = (0, _mui.styled)(_icons.ErrorCircle)(({
  theme
}) => ({
  color: theme.palette.error.main,
  fontSize: '35px',
  lineHeight: '24px'
}));
const StyledDeleteIcon = exports.StyledDeleteIcon = (0, _mui.styled)(_icons.Clear)(({
  theme
}) => ({
  fontSize: '23px',
  lineHeight: '16px',
  '&:hover': {
    background: 'transparent',
    color: theme.palette.primary.main
  },
  marginRight: theme.spacing(3)
}));
const StyledProgress = exports.StyledProgress = (0, _mui.styled)(_mui.LinearProgress)(({
  theme
}) => ({
  position: 'absolute',
  right: 0,
  bottom: '5px',
  left: 0
}));